import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { setToken } from "store/authSlice";
import { useDispatch } from "react-redux";

const Logout = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [errors, setErrors] = useState(false);

  useEffect(() => {
    dispatch(setToken({}));
    if (location?.state && location?.state?.authFailed) {
      setErrors(location?.state?.message);
      return;
    }
  }, []);

  return (
    <>
      <h2 className="text-center py-2">{errors}</h2>
    </>
  );
};

export default Logout;
